import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {HighChartContainer} from '../Common/HighChartContainer';
import {TotalResultContainer} from '../Common/TotalResultContainer';
import {
    IConfigSchema,
    TYPE_COLUMN_HIGH_CHART,
    TYPE_COLUMN_TOTAL,
    TYPE_COLUMN_TABLE,
    ITableResultData
} from '../resources/config-schema';
import {TableResultContainer} from './TableResultContainer';

interface IChartsContainerProps {
    configSchema: IConfigSchema;
}

export function ChartsContainer({configSchema}: IChartsContainerProps) {
    return (
        <>
            {configSchema.map((chartSection, index) => (
                <div key={index}>  
                    {chartSection?.titleSection && 
                        <Box marginY={2}>
                            <Typography
                                variant='h6'
                            >
                                {chartSection.titleSection.title}
                            </Typography>
                        </Box>
                    }
                    {chartSection.rows.map((row, index) =>
                        <Grid key={index} container columnSpacing={{ xs: 1, sm: 2, md: 3 }} marginY={2}>
                            {row.columns.map((column, index) =>
                                <Grid key={index} item xs={12 / row.columns.length}>
                                    {column.typeChart === TYPE_COLUMN_TOTAL &&
                                        <TotalResultContainer
                                            title={column.title || ''}
                                            total={column.transformData as number|string}
                                        />
                                    }
                                    {column.typeChart === TYPE_COLUMN_HIGH_CHART &&
                                        <HighChartContainer
                                            options={column.transformData as Highcharts.Options}
                                            chartType={column.chartType}
                                        />
                                    }
                                    {column.typeChart === TYPE_COLUMN_TABLE &&
                                        <TableResultContainer
                                            title={column.title || ''}
                                            data={column.transformData as ITableResultData}
                                        />
                                    }
                                </Grid>
                            )}
                        </Grid>
                    )}
                </div>
            ))}
        </>
    )
}